import useSWR from 'swr'
import { kuroApi } from '@/modules/kuro/api'
import type { KuroAboutData } from '@/modules/kuro/types'
import type { DataSnapshot } from '@/lib/schemas/snapshot'
import { fetcher } from '@/lib/swr'

export interface UseKuroAboutResult {
  data: KuroAboutData | undefined
  isLoading: boolean
  isError: boolean
  error: Error | undefined
  mutate: () => void
}

export function useKuroAbout(): UseKuroAboutResult {
  const { data: snapshot, error, isLoading, mutate } = useSWR<DataSnapshot<KuroAboutData>>(
    kuroApi.about(),
    fetcher,
    { refreshInterval: 3600000 } // 1 hour — about data changes rarely
  )

  return {
    data: snapshot?.data,
    isLoading,
    isError: !!error,
    error: error || undefined,
    mutate,
  }
}
